<div class="email-template-main-box">
  <p *ngIf="titleOrBodyIsEmpty" class="email-template-warning" >
    title and body are both required
  </p>
  <p-toast></p-toast>
    <div *ngIf="emailTemplates">
      <div class="email-template-button-container">
        <p-button label="Make combined Template"
          *ngIf="!addingNew && !updatingTemplate && !makingCombinedTemplate && !selectedTemplate"
          (onClick)="addCombinedTemplate()"></p-button>
      </div>

        <div class="email-template-add-new-box" *ngIf="addingNew">
            <p-button label="Make combined Template"
            *ngIf="!updatingTemplate && !makingCombinedTemplate && !selectedTemplate"
            (onClick)="addCombinedTemplate()"></p-button>
          <div [formGroup]="templateForm">
            <select formControlName="language">
              <option [ngValue]="language" *ngFor="let language of languages">{{language.name | titlecase}}</option>
            </select>
              <input placeholder="Title" formControlName="title">
              <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
              <div formArrayName="links" *ngFor="let array of linksFormArray; let i = index;">
                <div [formGroupName]="i" class="email-template-link-container">
                  <input placeholder="URL (required)" formControlName="url">
                  <input placeholder="Text (Optional)" formControlName="text">
                </div>
              </div>
          </div>
          <div class="email-template-button-container">
            <p-button label="Submit" (onClick)="sendForm()"></p-button>
            <p-button label="Cancel" (onClick)="cancelAdd()"></p-button>
            <p-button label="Add Link" (onClick)="addItem()"></p-button>
          </div>
        </div>

        <div *ngIf="makingCombinedTemplate">
          <p>Language: {{selectedLanguage!.name | titlecase}}</p>

              <div class="email-template-save-cancel-add-select-language-container">
                <p-button label="New Template" *ngIf="!addingNew && !updatingTemplate" (onClick)="addTemplate()">
                </p-button>
                <p-selectButton [options]="languageOptions" [(ngModel)]="selectedLanguage" (onChange)="switchLanguage()"></p-selectButton>
                  <p-button [disabled]="!selectedTemplate" label="Save change" (onClick)="updateTemplate()"></p-button>
                  <p-button label="Cancel" styleClass="p-button-warning" (onClick)="cancelCombinedTemplate()"></p-button>
                  <p-button [disabled]="!selectedTemplate" label="Delete" styleClass="p-button-danger" (onClick)="deleteTemplate()"></p-button>
              </div>
              <div class="email-template-template-editor-container">
                <div class="email-template-list-container">
                  <div class="email-template-search-box">
                    <p-radioButton name="groupname" value="title" [(ngModel)]="searchOption"></p-radioButton>Title
                    <p-radioButton name="groupname" value="body" [(ngModel)]="searchOption"></p-radioButton>Content
                      <input pInputText type="text" [(ngModel)]="searchTerm">
                  </div>

                  <div class="email-template-template-list-wrap">
                    <p-table selectionMode="single" [value]="emailTemplates | jsonFilter:[searchTerm, searchOption]">
                      <ng-template pTemplate="body" let-template>
                        <tr [pSelectableRow]="template">
                          <td (click)="selectTemplate(template)">
                            {{template.title}}
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
                <div [formGroup]="templateForm">
                  <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
                  <input type="text" placeholder="Title" formControlName="title" class="email-template-title-box">
                  <div  formArrayName="links" *ngFor="let array of linksFormArray; let i = index;">
                    <div [formGroupName]="i" class="email-template-link-container">
                      <input placeholder="URL (required)" formControlName="url">
                      <input placeholder="Text (Optional)" formControlName="text">
                    </div>
                  </div>
                </div>

                <div class="email-template-add-button-container" *ngIf="selectedTemplate">
                  <div class="email-template-add-wrap">
                      <p>
                          Add from selected
                      </p> 
                      <p-button label=">>" (onClick)="addSelected()"></p-button>
                  </div>
                  <div class="email-template-clear-wrap">
                    <p>
                      Clear editor
                    </p>
                    <p-button label="Clear" (onClick)="clearCombinedEditor()"></p-button>
                  </div>
                </div>
                <div [formGroup]="responseMailForm" *ngIf="responseMailForm">
                  <div class="email-template-mail-form-container">
                    <p>
                      Compose
                    </p>
                    <input placeholder="to" formControlName="to">
                    <input placeholder="subject" formControlName="subject">
                    <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
                  </div>
                  <p *ngIf="!hasGoogleRefreshToken" class="email-template-warning">Your account is not connected to Google account yet. Please contact system administrator.</p>
                  <p-button (onClick)="sendGmail()" label="Send" *ngIf="!sendingEmail"></p-button>
                  <p-progressSpinner [style]="{width: '46px', height: '46px'}" strokeWidth="5" animationDuration="1s" *ngIf="sendingEmail"></p-progressSpinner>
                </div>
                <div>
                  <div class="table-container" *ngIf="selectedContactRequest">
                    <table>
                      <tr>
                        <td colspan="2">
                          <h4>
                            Contact Request
                          </h4>
                        </td>
                      </tr>
                        <tr>
                            <td>
                                Name
                            </td>
                            <td>
                                {{selectedContactRequest.firstName}} {{selectedContactRequest.familyName}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Language
                            </td>
                            <td>
                                {{selectedContactRequest.language}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                City
                            </td>
                            <td>
                                {{selectedContactRequest.city}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Country
                            </td>
                            <td>
                                {{selectedContactRequest.country}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Phone number
                            </td>
                            <td>
                                {{selectedContactRequest.phoneNumber}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Email
                            </td>
                            <td>
                                {{selectedContactRequest.email}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Interested by
                            </td>
                            <td>
                                {{selectedContactRequest.interestedIn}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Message
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                {{selectedContactRequest.message}}
                            </td>
                        </tr>
                    </table>
            
                </div>
                </div>
              </div>
        </div>
      </div>
</div>
